import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import SearchIcon from "@material-ui/icons/Search";
import { MdClose } from "react-icons/md";
import styles from "./SearchBar.module.css";

const SearchBar = ({ value = "", onChange, label }) => {
  const [isInputInFocus, setisInputInFocus] = useState(null);

  return (
    <div className={clsx(styles.container, isInputInFocus && styles.inFocus)}>
      <input
        className={styles.input}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setisInputInFocus(true)}
        onBlur={() => setisInputInFocus(false)}
        id="header-search"
        data-testid="header-search"
        aria-label={label}
      />
      {value ? (
        <MdClose
          className={clsx(styles.icon, styles.clickable)}
          onClick={() => onChange("")}
        />
      ) : (
        <SearchIcon className={styles.icon} />
      )}
    </div>
  );
};

SearchBar.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default SearchBar;
